import { Injectable } from '@angular/core';
import { HyperFormula } from 'hyperformula';
import { HYPER_FORMULA_OPTIONS } from '../../constants';

@Injectable({
  providedIn: 'root',
})
export class HyperFormulaDataService {
  readonly instance = HyperFormula.buildEmpty(HYPER_FORMULA_OPTIONS);

  sheetIdMapping: string[] = [];

  clear() {
    const allSheetIds = this.instance
      .getSheetNames()
      .map((name) => this.instance.getSheetId(name))
      .filter((id) => id !== undefined) as number[];

    for (const sheetId of allSheetIds) {
      this.instance.removeSheet(sheetId);
    }

    this.sheetIdMapping = [];
  }
}
